import { render, staticRenderFns } from "./AlbumRow.vue?vue&type=template&id=72350d30"
import script from "./AlbumRow.vue?vue&type=script&lang=js"
export * from "./AlbumRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports